import { put, select, takeEvery } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';

import { Saga } from 'redux-saga';
import type { CoreActionCreator } from '../core/resourceStoreTypes';
import { featureFlagsSelectors } from '../feature-flags';
import * as actions from './securitiesActions';
import { getLastSyncDate } from './securitiesSelectors';
import { transformResponseToResources } from './securitiesTransformers';
import { Security, type SecurityProps, mkSecurity } from './securitiesTypes';

const mkQcsSyncSecuritiesConfig = resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<SecurityProps>();

const mkResourceConfig = (successAction: CoreActionCreator<any, any>, failureAction: CoreActionCreator<any, any>) =>
  mkQcsSyncSecuritiesConfig({
    resourceName: 'securities',
    resourceBaseUrl: '/v2/investments/securities',
    getLastSyncDate,
    applyResourceFromCRUDResponse: true,

    transformResponseToResources,

    successAction,
    failureAction,
  });

export function* getSecuritiesActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.getSecuritiesSuccess, actions.getSecuritiesFailure);
  yield resourceSagaUtils.takeAndDebounce(actions.getSecurities, resourceSagaUtils.qcsSyncGetResources, resourceConfig);
}

export function* createSecurityActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.createSecuritySuccess, actions.createSecurityFailure);
  yield takeEvery(actions.createSecurity.type, resourceSagaUtils.qcsSyncCreateResource<SecurityProps>, resourceConfig);
}

export function* updateSecurityActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.updateSecuritySuccess, actions.updateSecurityFailure);
  yield takeEvery(actions.updateSecurity.type, resourceSagaUtils.qcsSyncUpdateResource<SecurityProps>, resourceConfig);
}

export function* deleteSecurityActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.deleteSecuritySuccess, actions.deleteSecurityFailure);
  yield takeEvery(actions.deleteSecurity.type, resourceSagaUtils.qcsSyncDeleteResource<SecurityProps>, resourceConfig);
}

const { callFirst, callLast } = resourceSagaUtils.createGreedDebounce('securitiesDumpUpdater');
export function* securitiesDumpUpdater(resources: SecurityProps[]) {
  const bumpSecurities: boolean = yield select(featureFlagsSelectors.getFeatureFlag, 'bumpSecurities');
  if (bumpSecurities) {
    yield callFirst(securitiesDumpUpdaterFull, resources);
    yield callLast(securitiesNudgeUpdater as Saga);
  }
}

function* securitiesDumpUpdaterFull(resources: Array<Security>) {
  const securities = resources.map((resource) => mkSecurity(resource));
  yield put(actions.getSecuritiesSuccess({ resources: securities }, { context: 'BUMP_CHANGE_DUMP' }));
}

export function* securitiesNudgeUpdater() {
  const bumpSecurities: boolean = yield select(featureFlagsSelectors.getFeatureFlag, 'bumpSecurities');
  if (bumpSecurities) {
    yield put(actions.getSecurities(undefined, { context: 'BUMP_CHANGE_NUDGE' }));
  }
}

export default [
  getSecuritiesActionWatcher,
  createSecurityActionWatcher,
  updateSecurityActionWatcher,
  deleteSecurityActionWatcher,
];
